if(!customElements.get('color-swatch')) {
    class ColorSwatch extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            console.log(this);
            this.addEventListener('click', event => {
                console.log(event.target);
                window.location.href = event.target.closest('input').value;
            })
        }
    }
    customElements.define('color-swatch', ColorSwatch);
}